import {DisplayNameFormState} from './DisplayNameForm-State'
import {errorsList, errorsPresent, mergeServerValidationErrors} from '../../../../helpers/ErrorHelper'
import {endOfURL} from '../../../../helpers/UrlHelper'
import {isObject} from "../../../../helpers/DataHelper";

export default function displayNameFormReducer(state = DisplayNameFormState, action) {

    let {data} = {...state};
    let {validationErrors, value, mode, site_id,org_id, display_name} = action;
    switch (action.type) {

        case 'ON-DISPLAY-NAME-FORM-CHANGE':
            data.payload["display_name"] = value;
            buildErrors();
            return {...state, data};

        case 'ON-DISPLAY-NAME-FORM-MODE-CHANGE':
            data.mode = mode;
            buildErrors();
            return {...state, data};

        case 'SET-SITE-ID':
            data.site_id = site_id;
            buildErrors();
            return {...state, data};
        case 'INITIAL-SITE-NAME':
            data.payload["display_name"] = display_name;
            buildErrors();
            return {...state, data};
        case 'SET-ORGANIZATION-ID':
            data.organization_id = org_id;
            buildErrors();
            return {...state, data};
        case 'SET-DEFAULT-DISPLAY-NAME-FORM':
            data = {
                payload: {
                    display_name: '',
                },
                errors: [],
                errorsPresent: false,
                submitted: false,
                dispatchAPI: false,
                mode: endOfURL(),
                message: ``
            };
            buildErrors();
            return {...state, data};

        case 'CANCEL-DISPLAY-NAME-FORM-DISPATCH':
            data.dispatchAPI = false;
            data.submitted = false;
            buildErrors();
            return {...state, data};

        case 'ON-DISPLAY-NAME-FORM-SUBMIT':
            data.submitted = true;
            buildErrors();
            if (!data.errorsPresent) data.dispatchAPI = true;
            return {...state, data};

        case 'DISPLAY-NAME-FORM-SERVER-VALIDATION-ERRORS':
            validationErrors && isObject(validationErrors) &&
            Object.keys(validationErrors).map(key =>
                data.errors[key] = [{message: ` - ${validationErrors[key][0]}`.slice(0, -1)}]
            );
            data.dispatchAPI = false;
            return {...state, data};

        default:
            return state
    }

    function buildErrors() {
        data.errors = errorsList(errors)
        data.errorsPresent = errorsPresent(errors)
    }

    function errors(field) {
        let {payload, submitted, validationErrors} = data;
        let errors = {};
        Object.keys(payload).map(key => errors[key] = []);

        if (submitted) {
            if (field === `display_name`) {
                if (!_(field)) newError(field, 0, `is required`)
            }
        }

        errors = mergeServerValidationErrors(errors, validationErrors)

        return field ? errors[field] : errors

        function newError(field, step, message) {
            errors && errors[field].push({step, message})
        }

        function _(field) {
            return data.payload[field]
        }
    }
}